import { Flex, Radio, RadioGroup, HStack } from '@chakra-ui/react';

import SectionCard from '../../components/SectionCard';
import { POLICY_DISCOUNTS, type PolicyDiscountProps } from './types';

const PolicyDiscount = ({
  policyDiscount,
  onFieldChange,
}: PolicyDiscountProps) => {
  return (
    <SectionCard title="Policy Discount" mb={4}>
      <Flex gap={6} align="center" flexWrap="wrap">
        <RadioGroup
          value={policyDiscount}
          onChange={(v) => onFieldChange('policy_discount', v)}
        >
          <HStack spacing={4}>
            {POLICY_DISCOUNTS.map((d) => (
              <Radio key={d.value} value={d.value} colorScheme="blue">
                {d.label}
              </Radio>
            ))}
          </HStack>
        </RadioGroup>
      </Flex>
    </SectionCard>
  );
};

export default PolicyDiscount;
